import { unitPrecision, designRatio, divisor } from "@/constants/runtime.config";
import { Toast } from "antd-mobile";
import qs from "qs";
export const pxChangeRem = (px: number | string | undefined) => {
  px = parseFloat(px as string);
  const value = Math.round((px / designRatio) * divisor ** unitPrecision) / divisor ** unitPrecision;
  return value + "rem";
};
export const pxChangeVw = (px: string | number | undefined, _isNumber = false) => {
  // px = parseFloat(px as string);
  // const innerWidth = window.innerWidth;
  // if (innerWidth >= maxDisplayWidth) {
  //   return Math.round(((px * maxDisplayWidth) / designWidth) * 10 ** unitPrecision) / 10 ** unitPrecision + "px";
  // }
  // const value = Math.round(((px * 100) / designWidth) * 10 ** unitPrecision) / 10 ** unitPrecision;
  // return isNumber ? value : value + "vw";
  return pxChangeRem(px);
};
// export const pxToVw = (px: string | number | undefined) => {
//   px = parseFloat(px as string);
//   const innerWidth = window.innerWidth;
//   if (innerWidth >= maxDisplayWidth) return ((px * maxDisplayWidth) / designWidth).toFixed(unitPrecision) + "px";
//   return ((px / designWidth) * 100).toFixed(unitPrecision) + "vw";
// };
// export const pxToVh = (px: string | number) => {
//   px = parseFloat(px as string);
//   return ((px / 812) * 100).toFixed(unitPrecision) + "vh";
// };

export const debounce = (fn: Function, delay: number = 300) => {
  let timer: any = null;
  return function (...args: any[]) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(fn.bind(null, ...args), delay);
  };
};

export function getHashParams(url: string | URL) {
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  return {
    protocol: urlObj.protocol,
    host: urlObj.host,
    pathname: urlObj.pathname,
    search: urlObj.search,
    params: Object.fromEntries(params.entries()),
  };
}

export function parseURL(url: string) {
  const parser = document.createElement("a");
  parser.href = url;
  const parsedURL = {
    protocol: parser.protocol,
    hostname: parser.hostname,
    port: parser.port,
    path: parser.pathname,
    query: parser.search,
    hash: parser.hash,
  };
  return parsedURL;
}

export function getParams(strlen: any, str: string | number) {
  let c = strlen;
  if (c.includes("?")) {
    c = c.split("?")[1];
  }
  const obj = qs.parse(c) || {};
  return obj[str] || "";
}

export function formatFileSize(size: number, pointLength = 2) {
  if (size < 1024) {
    return size + "B";
  } else if (size < 1024 * 1024) {
    return (size / 1024).toFixed(pointLength) + "KB";
  } else {
    return (size / 1024 / 1024).toFixed(pointLength) + "MB";
  }
}

export function getSearchParam(key: string, href = window.location.href) {
  const url = new URL(href);
  const search = url.search;
  const hash = url.hash;
  const hashSearch = hash.split("?")[1];
  let combinedSearch = search;
  if (hashSearch) {
    combinedSearch += (search ? "&" : "?") + hashSearch;
  }
  const usp = new URLSearchParams(combinedSearch);
  return usp.get(key);
}

export function getParamType(paramKey: string = "_t", url: string | URL = window.location.href) {
  const urlObj = new URL(url);
  const searchParams = new URLSearchParams(urlObj.search.substring(1));
  const index = urlObj.hash.indexOf("?");
  const hashParams = new URLSearchParams(urlObj.hash.substring(index + 1));
  if (searchParams.has(paramKey)) {
    return "search";
  } else if (hashParams.has(paramKey)) {
    return "hash";
  }
  return "not found";
}
export function setSearchParams(paramKey: string = "_t", paramValue: any = Date.now()) {
  const url = new URL(location.href);
  url.searchParams.set(paramKey, paramValue);
  window.history.replaceState({}, "", url.toString());
}

export function randomEl(arr: string | any[] = [1, 2, 3, 4, 5, 6, 7, 8]) {
  var index = Math.floor(Math.random() * arr.length);
  return arr[index];
}

export function buildUrl(baseUrl: string, params: Record<string, any>): string {
  const query = Object.keys(params)
    .map(key => `${encodeURI(key)}=${encodeURI(params[key])}`)
    .join("&");
  return `${baseUrl}?${query}`;
}

export const copyText = (text: string) => {
  return new Promise((resolve, reject) => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          Toast.show({
            position: "top",
            duration: 1000,
            content: "复制成功",
            maskClickable: false,
          });
          resolve(true);
        })
        .catch(err => {
          Toast.show({
            position: "top",
            duration: 1000,
            content: "复制失败",
            maskClickable: false,
          });
          reject(err);
        });
    } else {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", text);
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, 9999);
      if (document.execCommand("copy")) {
        resolve(true);
      } else {
        reject(false);
      }
      document.body.removeChild(input);
    }
  });
};

export async function getImageSize(img: { naturalWidth: number; naturalHeight: number; src: any }) {
  if (img.naturalWidth) {
    return {
      width: img.naturalWidth,
      height: img.naturalHeight,
      ratio: img.naturalWidth / img.naturalHeight,
    };
  } else {
    return await fetchImgSize(img.src);
  }
}
export function fetchImgSize(url: string) {
  return new Promise(function (resolve, reject) {
    const image = new Image();
    image.onload = function () {
      resolve({
        width: image.naturalWidth,
        height: image.naturalHeight,
        ratio: image.naturalWidth / image.naturalHeight,
      });
    };
    image.onerror = function () {
      reject(new Error("error"));
    };
    image.src = url;
  });
}

export function filterEmpty(object: any) {
  return Object.keys(object).reduce((acc: any, key) => {
    if (!isEmptyType(object[key])) {
      acc[key] = object[key];
    }
    return acc;
  }, {});
}

export const getImg = (str: string) => {
  try {
    const url = new URL(`../assets/img/${str}`, import.meta.url).href;
    return url.includes("undefined") ? "" : url;
  } catch (error) {
    console.warn(`Image file not found: ${str}`, error);
    return "";
  }
};

export const getIcon = (str: any) => {
  try {
    const url = new URL(`../assets/icons/${str}`, import.meta.url).href;
    return url.includes("undefined") ? "" : url;
  } catch (error) {
    console.warn(`Icon file not found: ${str}`, error);
    return "";
  }
};

export const getSvg = (str: any) => {
  try {
    const url = new URL(`../assets/icons/${str}`, import.meta.url).href;
    return url.includes("undefined") ? "" : url;
  } catch (error) {
    console.warn(`SVG file not found: ${str}`, error);
    return "";
  }
};

export function loadScript(url: string, callback: () => void, cors = true) {
  try {
    const script: any = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    cors && script.setAttribute("crossorigin", "anonymous");
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
      script.onerror = (event: any) => {
        console.log(event);
      };
    }
    script.src = url;
    document.head.appendChild(script);
  } catch (e) {
    console.error("Error loading script:", e);
  }
}

export function checkTestHost(testUrls: string[] = []) {
  const { hostName } = useHostName();
  return ["test.comfortweather.com", "www.comfortweather.com"].includes(hostName) && testUrls.includes(hostName);
}

import { flatten, omit } from "lodash";
export function flatOmit(domainMap: Record<string, any>, keysToOmit: string[]): any[] {
  return flatten(Object.values(omit(domainMap, keysToOmit)));
}

export function isInDomainMap(domainMap: Record<string, any>, keyToOmit: string[]): boolean {
  const { hostName } = useHostName();
  return flatOmit(domainMap, keyToOmit).includes(hostName);
}

export const chunkArray: any = (array: any[], size: number) => {
  if (!array) {
    return [];
  }
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

// 创建多个不同的 key 对应同一个 value 值
export const keysVsVal = (keys: any[], value: any) => {
  return keys.reduce(
    (acc, key) => {
      acc[key] = value;
      return acc;
    },
    {} as Record<string, any>,
  );
};

// 使用示例 const obj3 = keysVsVal(["key1", "key2", "key3"], sharedValue);

// 创建同一个 key 对应多个不同 value

interface IMultiValue {
  [key: string]: (number | string)[];
}
export function keyVsVals(entries: [string, (number | string)[]][]): IMultiValue {
  return entries.reduce((acc, [key, values]) => {
    acc[key] = values;
    return acc;
  }, {} as IMultiValue);
}

// 使用示例 const obj4 = keyVsVals([["status", [200, 404, 500]],["methods", ["GET", "POST"]]]);

export const formatDate = (timestamp: number | string) => {
  const { dayjs } = useDayjs();
  return dayjs.unix(Number(timestamp)).format("DD-MMM-YYYY");
};

export function generateSequentialSuffix(str: string, currentSuffix = 0) {
  if (!str) {
    return str;
  }
  const regex = /(\d+)(?!.*\d)/;
  const match = str.match(regex);
  if (!match) {
    console.warn("字符串末尾没有找到数字部分，返回原字符串");
    return str;
  }
  currentSuffix += 1;
  return str.replace(regex, currentSuffix.toString());
}

/**
 * 从URL中提取hash部分
 * @param {string} urlStr - 完整的URL字符串
 * @param {Object} [options] - 配置选项
 * @param {boolean} [options.keepHashSymbol=true] - 是否保留#符号（默认保留）
 * @param {boolean} [options.removeParams=true] - 是否移除hash后面的参数（默认移除）
 * @returns {string} 处理后的hash部分
 */
export function getHashFromUrl(urlStr: string | URL = window.location.href, options: any = {}) {
  const { keepHashSymbol = true, removeParams = true } = options;

  try {
    const url = new URL(urlStr);
    let hash = url.hash;

    if (removeParams && hash.includes("?")) {
      hash = hash.split("?")[0];
    }

    if (!keepHashSymbol) {
      hash = hash.replace("#", "");
    }

    return hash;
  } catch (error) {
    console.error("Invalid URL:", error);
    return "";
  }
}
